// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__Vai5t","detailsBorder":"styles_detailsBorder__3x7mm"};